const StatisticsRetained = () =>
  import('@/views/main/live/statisticsRetained/StatisticsRetained.vue')
export default {
  path: '/main/live/statisticsRetained',
  name: 'StatisticsRetained',
  component: StatisticsRetained,
  children: []
}
